import React, {useState, useEffect} from 'react';
 

export const DynamicPathImage = (props) => {
  const { src, ...newProps } = props;
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    src.then((loadedSrc) => {
      setImageSrc(loadedSrc);
    });
  }, [src]);

  return <img src={imageSrc} alt={''} {...newProps} />;
};
